import { Link } from "react-router-dom";
import { Download, FileJson } from "lucide-react";
import { BACKEND_URL } from "@/lib/api";

const FILES = [
  ["sample.json", "Basic example", "One-faced, double-faced, adventure and token cards with image names."],
  ["sample-advanced.json", "Advanced example", "A mechanics list, supertype / type / subtype lists, legendary cards and set numbers like 001/003."],
];

export function ExampleDownloads({ testid = "example-downloads", showImporterLink = false }) {
  return (
    <section className="panel space-y-4 p-5" data-testid={testid}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="eyebrow">Example JSON files</p>
        {showImporterLink && <Link to="/import" className="text-xs text-amber-300 hover:underline" data-testid={`${testid}-importer-link`}>Have a JSON card file? Use the importer</Link>}
      </div>
      <p className="text-sm text-slate-400">Download an example, change it (or ask ChatGPT to fill it in), then import it. The importer reads names, costs, legendary and other supertypes, card types, subtypes, stats, artist, set numbers and mechanics, and offers to add new mechanics to the Mechanics section.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {FILES.map(([file, title, text]) => (
          <a key={file} href={`${BACKEND_URL}/api/v1/imports/${file}`} className="flex gap-3 rounded-lg border border-[#2A3447] p-4 transition-colors hover:border-amber-500/60"
            data-testid={`${testid}-${file.replace(".json", "")}`}>
            <FileJson className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" />
            <span><span className="flex items-center gap-2 text-sm text-amber-100">{title}<Download className="h-3.5 w-3.5" /></span>
              <span className="text-xs text-slate-500">{text}</span></span>
          </a>
        ))}
      </div>
    </section>
  );
}
